<div class="custom-select-wrapper"
     [class.custom-select-wrapper--multiple]="multiple"
     [class.custom-select-wrapper--inline]="panelLayout === 'inline'"
     #wrapper>
  <button type="button"
          #triggerBtn
          class="select-trigger"
          [class.select-trigger--multiple]="multiple"
          [class.is-open]="isOpen"
          [attr.title]="multipleSelectionTitle || null"
          [attr.aria-label]="ariaLabelForTrigger"
          [class.is-disabled]="disabled"
          [attr.aria-disabled]="disabled"
          (click)="onTriggerClick($event)">
    <span class="select-trigger__leading">
      <i-feather
        *ngIf="selectedOptionFeatherIcon as iconName"
        [name]="iconName"
        class="select-trigger__option-icon"
        [ngClass]="selectedOptionIconToneClass"></i-feather>
      <span
        class="trigger-label"
        [class.trigger-label--multiple]="multiple"
        [class.trigger-label--muted]="showPlaceholderTriggerStyle">{{ displayLabel }}</span>
    </span>
    <i-feather [name]="isOpen ? 'chevron-up' : 'chevron-down'" class="trigger-arrow"></i-feather>
  </button>

  <div
    class="select-panel"
    *ngIf="isOpen"
    [class.select-panel--overlay]="panelLayout === 'overlay'"
    [class.select-panel--inline]="panelLayout === 'inline'"
    [ngStyle]="panelLayout === 'overlay' && panelPosition
      ? { top: panelPosition.top, left: panelPosition.left, minWidth: panelPosition.minWidth }
      : null"
    (mousedown)="$event.stopPropagation()"
    (click)="$event.stopPropagation()">
    <div class="panel-separator"></div>
    <div class="panel-options">
      <ng-container *ngIf="showAllOption && !multiple">
        <button type="button"
                class="panel-option"
                [class.is-selected]="effectiveValue === 'all'"
                [class.is-hovered]="hoveredValue === 'all'"
                (mousedown)="$event.stopPropagation()"
                (click)="selectOption('all'); $event.preventDefault(); $event.stopPropagation()"
                (mouseenter)="hoveredValue = 'all'"
                (mouseleave)="hoveredValue = null">
          {{ "All" | translate }}
        </button>
      </ng-container>
      <button type="button"
              *ngFor="let option of options; trackBy: trackByOptionValue"
              class="panel-option"
              [class.panel-option--multiple]="multiple"
              [class.is-selected]="isOptionSelected(option.value)"
              [class.is-hovered]="hoveredValue === option.value"
              [attr.aria-pressed]="multiple ? isOptionSelected(option.value) : null"
              (mousedown)="$event.stopPropagation()"
              (click)="selectOption(option.value); $event.preventDefault(); $event.stopPropagation()"
              (mouseenter)="hoveredValue = option.value"
              (mouseleave)="hoveredValue = null">
        <span *ngIf="multiple" class="panel-option-check" [class.is-checked]="isOptionSelected(option.value)" aria-hidden="true">
          <i-feather *ngIf="isOptionSelected(option.value)" name="check" class="panel-option-check-icon"></i-feather>
        </span>
        <span class="panel-option-row">
          <i-feather
            *ngIf="option.featherIcon"
            [name]="option.featherIcon"
            class="panel-option-icon"
            [ngClass]="option.iconTone ? 'panel-option-icon--' + option.iconTone : null"></i-feather>
          <span class="panel-option-label">{{ labelsAlreadyTranslated ? option.label : (option.label | translate) }}</span>
          <span class="panel-option-count" *ngIf="option.count != null">{{ option.count }}</span>
        </span>
      </button>
    </div>
  </div>
</div>
